"use client";

import Icon from "@/components/Icon";
import classNames from "@/helpers/classNames";
import styles from "./styles.module.scss";

interface SearchButtonProps {
  className?: string;
  isActive?: boolean;
  onClick?: () => void;
}

const SearchButton = ({ className, isActive, onClick }: SearchButtonProps) => (
  <button
    type="button"
    className={classNames(styles.searchButton, { [styles.active]: isActive }, className)}
    aria-label={isActive ? "Close search" : "Search"}
    onClick={onClick}
  >
    <figure className={styles.iconContainer}>
      <Icon
        title="close"
        className={classNames(styles.icon, styles.left, styles.hoverIcon)}
        color="themeFgDefault"
      />
      <Icon
        title="magnifyingGlass"
        className={classNames(styles.icon, styles.right)}
        color="themeFgDefault"
      />
    </figure>
  </button>
);

export default SearchButton;
